import React, { useState, useEffect, useMemo } from 'react';
import { toast } from 'react-hot-toast';
import { useSetting } from '../../../../context/SettingContext';
import { updateSetting } from '../../../../controllers/SettingController';
import ButtonPrimary from '../../../../components/button/ButtonPrimary';

const Card = ({ t }) => {
    const { setting } = useSetting();
    
    const [logoUrl, setLogoUrl] = useState(null);
    const [titleID, setTitleID] = useState('');
    const [titleEN, setTitleEN] = useState('');
    const [updatedBy, setUpdatedBy] = useState('');
    const [updatedAt, setUpdatedAt] = useState('');
    
    useEffect(() => {
        if (setting) {
            setTitleID(setting.title_id);
            setTitleEN(setting.title_en);
            setUpdatedBy(setting.updated_by);
            setUpdatedAt(setting.updated_at);
        };
    }, [setting]);
    
    const isDisabled = useMemo(() => {
        const isBasicFieldsValid = titleID.trim() && titleEN.trim();
        return !isBasicFieldsValid;
    }, [titleID, titleEN]);
    
    const handleUpdate = async () => {
        try {
            if (logoUrl && !logoUrl.type.startsWith('image/')) {
                toast.error(t('common.logoLink.errorMessageInvalidLogoType'));
                return;
            };
            
            const formData = new FormData();
            formData.append('title_id', titleID);
            formData.append('title_en', titleEN);
            
            if (logoUrl) {
                formData.append('logo_url', logoUrl);
            };
            
            await updateSetting(formData);
            window.location.reload();
        } catch (error) {
            toast.error(error.message);
        };
    };
    
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoUrl(file);
        };
    };
    
    return (
        <div className='space-y-5'>
            {/* Logo */}
            <div className='flex items-center justify-center rounded-lg'>
                <img
                    className='h-16 leading-[64px] md:h-32 md:leading-[128px] object-cover'
                    src={logoUrl ? URL.createObjectURL(logoUrl) : setting.logo_url}
                    alt='Logo'
                />
            </div>
            
            {/* Main Content */}
            <div className='flex flex-col p-5 rounded-lg bg-white space-y-5'>
                {/* Image upload */}
                <div className='flex flex-grow items-center'>
                    <span className='w-36 lg:w-64 text-xs md:text-sm'>{t('common.logoLink.title')}:</span>
                    <label
                        htmlFor='image-input'
                        className='w-full px-3 py-2 rounded border border-platinum text-xs md:text-sm cursor-pointer hover:outline-none hover:border-grayX11 focus:outline-none focus:border-blackOlive'
                    >
                        {t('common.logoLink.placeholderEdit')}
                        <input
                            type='file'
                            id='image-input'
                            accept='image/*'
                            className='hidden'
                            onChange={handleFileChange}
                        />
                    </label>
                </div>
                
                {/* Title */}
                <div className='flex flex-grow items-center'>
                    <span className='w-36 lg:w-64 text-xs md:text-sm'>{t('common.title.titleAlt')} ({t('languages.indonesian')}):</span>
                    <input
                        className={`
                            w-full px-3 py-2 rounded border border-platinum text-xs md:text-sm
                            hover:outline-none hover:border-grayX11
                            focus:outline-none focus:border-blackOlive
                        `}
                        type='text'
                        placeholder={t('common.title.placeholderText')}
                        value={titleID}
                        onChange={(e) => setTitleID(e.target.value)} 
                    />
                </div>
                <div className='flex flex-grow items-center'>
                    <span className='w-36 lg:w-64 text-xs md:text-sm'>{t('common.title.titleAlt')} ({t('languages.english')}):</span>
                    <input
                        className={`
                            w-full px-3 py-2 rounded border border-platinum text-xs md:text-sm
                            hover:outline-none hover:border-grayX11
                            focus:outline-none focus:border-blackOlive
                        `}
                        type='text'
                        placeholder={t('common.title.placeholderText')}
                        value={titleEN}
                        onChange={(e) => setTitleEN(e.target.value)} 
                    />
                </div>
                
                {/* Information */}
                <div className='flex flex-grow items-center'>
                    <span className='w-36 lg:w-64 text-xs md:text-sm'>{t('common.updated.by')}:</span>
                    <input
                        className={`
                            w-full px-3 py-2 rounded border border-platinum text-xs md:text-sm
                            hover:outline-none hover:border-grayX11
                            focus:outline-none focus:border-blackOlive
                        `}
                        type='text'
                        value={updatedBy}
                        disabled
                    />
                </div>
                <div className='flex flex-grow items-center'>
                    <span className='w-36 lg:w-64 text-xs md:text-sm'>{t('common.updated.title')}:</span>
                    <input
                        className={`
                            w-full px-3 py-2 rounded border border-platinum text-xs md:text-sm
                            hover:outline-none hover:border-grayX11
                            focus:outline-none focus:border-blackOlive
                        `}
                        type='text'
                        value={updatedAt}
                        disabled
                    />
                </div>
                <div className='flex justify-center sm:justify-end space-x-5'>
                    <ButtonPrimary className='h-full w-24 md:w-32 md:text-sm' isDisabled={isDisabled} onClick={handleUpdate}>{t('common.action.edit')}</ButtonPrimary>
                </div>
            </div>
        </div>
    );
};

export default Card;
